import { LOCATION_CHANGE } from 'react-router-redux';
import { handleActions } from 'redux-actions';
import { mapReducersFromConfigurations } from '../../helpers/reducer';
import { configurations } from './configurations';

export const initialState = {
  cpdPoints: [],
  relatedTasks: [],
  exportCpdPoints: undefined,
  totalCpdActivityCount: 0,
  filterHits: 0,
  isFetching: false,
  error: null
};

const reducer = handleActions({
  ...mapReducersFromConfigurations('cpdPoints')(configurations),
  [LOCATION_CHANGE]: (state, action) => ({
    ...state,
    exportCpdPoints: undefined,
    error: null
  })
}, {
    ...initialState
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/cpd-points/reducers.js